import api from "./api";
import { Banner } from "../types/store";

export const fetchBanners = async () => {
  const response = await api.get<Banner[]>("/banners");
  return response.data;
};

export const fetchOfferCards = async () => {
  const response = await api.get<Banner[]>("/banners/offer-cards");
  return response.data;
};

export const fetchOfferBanners = async () => {
  const response = await api.get<Banner[]>("/banners/offer-banners");
  return response.data;
};

export const fetchCategoriesBanner = async () => {
  const response = await api.get<Banner | null>("/banners/categories-banner");
  return response.data;
};
